import React, { forwardRef, RefObject } from "react";
import { CSSTransition } from "react-transition-group";
import { CSSTransitionProps } from "react-transition-group/CSSTransition";

import "./modal.css";

import BaseModal, { BaseModalUIProps } from "./BaseModal";
import ModalElement, { ModalElementProps } from "./ModalElement";

export interface ModalUIProps extends BaseModalUIProps {
    uiActive: boolean;
    uiTransitionTimeout?: CSSTransitionProps["timeout"];
    uiElementRef?: RefObject<HTMLElement>;
}

export type ModalProps = ModalElementProps & ModalUIProps;

const ModalComponent = forwardRef<BaseModal, ModalProps>((props, ref) => {
    const {
        uiActive = false,
        children,
        uiDefaultSizes = true,
        uiBasic = false,
        className,
        uiTransitionTimeout = 200,
        uiPosition,
        uiOffsetLeft,
        uiOffsetTop,
        uiCloseOnEsc,
        uiCloseOnOutsideClick,
        uiOnRequestClose,
        uiOnOpen,
        uiOnClose,
        uiElementRef,
        ...other
    } = props;

    return (
        <CSSTransition
            in={uiActive}
            appear
            enter
            exit
            mountOnEnter
            unmountOnExit
            classNames="transition"
            timeout={uiTransitionTimeout}
        >
            <BaseModal
                uiPosition={uiPosition}
                uiOffsetLeft={uiOffsetLeft}
                uiOffsetTop={uiOffsetTop}
                uiCloseOnEsc={uiCloseOnEsc}
                uiCloseOnOutsideClick={uiCloseOnOutsideClick}
                uiOnRequestClose={uiOnRequestClose}
                uiOnOpen={uiOnOpen}
                uiOnClose={uiOnClose}
                className="modal-overlay"
                ref={ref}
            >
                <ModalElement
                    {...other}
                    className={className}
                    uiBasic={uiBasic}
                    uiDefaultSizes={uiDefaultSizes}
                    ref={uiElementRef as any}
                >
                    {children}
                </ModalElement>
            </BaseModal>
        </CSSTransition>
    );
});

ModalComponent.displayName = "Modal";

const Modal = ModalComponent;

export default Modal;
